import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
export function DemoBanner() {
  const [dismissed, setDismissed] = useState(false);
  const {
    lang
  } = useLang();
  if (dismissed) return null;
  const ua = lang === 'ua';
  return <div className="fixed bottom-5 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-2xl" data-id="element-100">
      {/* Glassmorphism card */}
      <div className="relative overflow-hidden border border-white/20 shadow-2xl" style={{
      background: 'rgba(10, 10, 10, 0.75)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)'
    }} data-id="element-101">
        {/* Close */}
        <button onClick={() => setDismissed(true)} className="absolute top-3 right-3 p-1 text-white/40 hover:text-white transition-colors z-10" aria-label="Закрити" data-id="element-102">
          <X className="h-3.5 w-3.5" data-id="element-103" />
        </button>

        {/* MOBILE layout */}
        <div className="flex flex-col items-center text-center gap-3 p-5 md:hidden" data-id="element-104">
          {/* Icon + title in one row */}
          <div className="flex items-center gap-2 justify-center" data-id="element-105">
            <span style={{
            fontFamily: 'Apple Color Emoji, Segoe UI Emoji, Noto Color Emoji, sans-serif',
            fontSize: '20px',
            lineHeight: 1
          }} data-id="element-106">
              🖥️
            </span>
            <p className="font-bold text-sm text-white leading-snug" data-id="element-107">
              {ua ? 'Це демонстраційний сайт' : 'Это демонстрационный сайт'}
            </p>
          </div>

          {/* Description */}
          <p className="text-white/60 text-xs leading-relaxed max-w-xs" data-id="element-108">
            {ua ? <>
                Адаптуємо цей сайт під ваш бізнес або зробимо з нуля. Вартість:{' '}
                <span className="text-white font-semibold whitespace-nowrap" data-id="element-109">
                  9&nbsp;000&nbsp;грн
                </span>{' '}
                <span className="line-through text-white/30 whitespace-nowrap" data-id="element-110">
                  15&nbsp;000&nbsp;грн
                </span>
              </> : <>
                Адаптируем этот сайт под ваш бизнес или сделаем с нуля.
                Стоимость:{' '}
                <span className="text-white font-semibold whitespace-nowrap" data-id="element-111">
                  9&nbsp;000&nbsp;грн
                </span>{' '}
                <span className="line-through text-white/30 whitespace-nowrap" data-id="element-112">
                  15&nbsp;000&nbsp;грн
                </span>
              </>}
          </p>

          {/* Buttons */}
          <div className="flex flex-col w-full gap-2 max-w-xs" data-id="element-113">
            <a href="https://jetly.agency/ua" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center bg-white text-black text-xs font-bold px-4 py-2.5 hover:bg-neutral-100 transition-colors" data-id="element-114">
              {ua ? 'Замовити сайт' : 'Заказать сайт'}
            </a>
            <a href="https://t.me/jetly_agency" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-1.5 border border-white/30 text-white text-xs font-medium px-4 py-2.5 hover:border-white transition-colors" data-id="element-115">
              <svg className="h-3.5 w-3.5 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor" data-id="element-116">
                <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.12l-6.871 4.326-2.962-.924c-.643-.204-.657-.643.136-.953l11.57-4.461c.537-.194 1.006.131.833.941z" data-id="element-117" />
              </svg>
              Telegram
            </a>
          </div>
        </div>

        {/* DESKTOP layout */}
        <div className="hidden md:flex items-center gap-4 px-5 py-4 pr-10" data-id="element-118">
          {/* Icon */}
          <span className="flex-shrink-0" style={{
          fontFamily: 'Apple Color Emoji, Segoe UI Emoji, Noto Color Emoji, sans-serif',
          fontSize: '26px',
          lineHeight: 1
        }} data-id="element-119">
            🖥️
          </span>

          {/* Text */}
          <div className="flex-1 min-w-0" data-id="element-120">
            <p className="font-bold text-sm text-white mb-0.5" data-id="element-121">
              {ua ? 'Це демонстраційний сайт' : 'Это демонстрационный сайт'}
            </p>
            <p className="text-white/60 text-xs leading-snug" data-id="element-122">
              {ua ? <>
                  Адаптуємо цей сайт під ваш бізнес або зробимо з нуля.
                  Вартість:{' '}
                  <span className="text-white font-semibold whitespace-nowrap" data-id="element-123">
                    9&nbsp;000&nbsp;грн
                  </span>{' '}
                  <span className="line-through text-white/30 whitespace-nowrap" data-id="element-124">
                    15&nbsp;000&nbsp;грн
                  </span>
                </> : <>
                  Адаптируем этот сайт под ваш бизнес или сделаем с нуля.
                  Стоимость:{' '}
                  <span className="text-white font-semibold whitespace-nowrap" data-id="element-125">
                    9&nbsp;000&nbsp;грн
                  </span>{' '}
                  <span className="line-through text-white/30 whitespace-nowrap" data-id="element-126">
                    15&nbsp;000&nbsp;грн
                  </span>
                </>}
            </p>
          </div>

          {/* Buttons */}
          <div className="flex items-center gap-2 flex-shrink-0" data-id="element-127">
            <a href="https://jetly.agency/ua" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-white text-black text-xs font-bold px-4 py-2 hover:bg-neutral-100 transition-colors whitespace-nowrap" data-id="element-128">
              {ua ? 'Замовити сайт' : 'Заказать сайт'}
            </a>
            <a href="https://t.me/jetly_agency" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-1.5 border border-white/30 text-white text-xs font-medium px-4 py-2 hover:border-white transition-colors whitespace-nowrap" data-id="element-129">
              <svg className="h-3.5 w-3.5 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor" data-id="element-130">
                <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.12l-6.871 4.326-2.962-.924c-.643-.204-.657-.643.136-.953l11.57-4.461c.537-.194 1.006.131.833.941z" data-id="element-131" />
              </svg>
              Telegram
            </a>
          </div>
        </div>
      </div>
    </div>;
}